import { getRoleArr} from '@/utils/tool';
export default [{
  path: '/system/system',
  icon: require("@/assets/nav-icon/system/1.png"),
  checkIcon: require("@/assets/nav-icon/system/1-1.png"),
  id: 1,
  name: '系统设置',
  show: getRoleArr('manage.system.config')
}, {
  path: '/system/manage_list',
  icon: require("@/assets/nav-icon/system/2.png"),
  checkIcon: require("@/assets/nav-icon/system/2-1.png"),
  id: 2,
  name: '系统管理员',
  show: getRoleArr('manage.system.manage.list')
}, 
{
  path: '/system/operateLog',
  icon: require("@/assets/nav-icon/system/3.png"),
  checkIcon: require("@/assets/nav-icon/system/3-1.png"),
  id: 3,
  name: '管理员日志',
  show: getRoleArr('manage.system.operateLog')
}, 
{
  path: '/system/password',
  icon: require("@/assets/nav-icon/system/4.png"),
  checkIcon: require("@/assets/nav-icon/system/4-1.png"),
  id: 4,
  name: '修改密码',
  // show: getRoleArr('manage.member.list'),
  isShow:1
}, {
  path: '/system/confidentialityAgreement',
  icon: require("@/assets/nav-icon/system/5.png"),
  checkIcon: require("@/assets/nav-icon/system/5-1.png"),
  id: 5,
  name: '保密协议',
  show: getRoleArr('manage.system.confidentialityAgreement')
}]